import { render, staticRenderFns } from "./ProgramAdminExpansion.vue?vue&type=template&id=eb3d083c&scoped=true"
import script from "./ProgramAdminExpansion.vue?vue&type=script&lang=js"
export * from "./ProgramAdminExpansion.vue?vue&type=script&lang=js"
import style0 from "./ProgramAdminExpansion.vue?vue&type=style&index=0&id=eb3d083c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb3d083c",
  null
  
)

export default component.exports